jQuery(document).ready(function($){ 
    $('.tab-a').click(function(){  
      $(".tab").removeClass('tab-active');
      $(".tab[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
      $(".tab-a").removeClass('active-a');
      $(this).parent().find(".tab-a").addClass('active-a');
     });

  
    /* macth height start*/
  	
  
  $('.productitem .productitem--info').matchHeight({
    	 byRow: false
  });
  $('.productgrid--item').matchHeight({
    	 byRow: false
  });


  
    /*calculator start*/
  	  

    var currentSlide = $('.range-slider__range').val();
    var statVal = parseInt(currentSlide) * 0.01945;
    var fiststatVal = Math.ceil(statVal);
    var fiststatValamountwithcurrency = "$ "+fiststatVal;
    $("#emi-amount").html(fiststatValamountwithcurrency);

    var rangeSlider = function(){
      var slider = $('.range-slider'),
          range = $('.range-slider__range'),
          value = $('.range-slider__value');
        
      slider.each(function(){

        value.each(function(){
          var value = $(this).next().attr('value');
          $(this).html(value);
        });
    	

    	var product_price ='';
    	var interest_rate = '';
        range.on('input', function(){
          var renderfinalamountwithcurrency = "$ "+this.value;	
          $(".range-slider__value").html(renderfinalamountwithcurrency);	
          $(this).next(value).html(this.value);
          product_price = parseInt(this.value); 
          interest_rate = 0.01945;

          if( product_price >= 4000 && product_price <= 49000 ){
            var interest_rate = 0.01945;
          }else if( product_price >= 50000 && product_price <= 100000 ){
            var interest_rate = 0.01905;
          }else if( product_price >= 100000){
            var interest_rate = 0.01880;
          }

          var finalamount = product_price*interest_rate;
          var roudupfinalamount = Math.ceil(finalamount);
          var roudupfinalamountwithcurrency = "$ "+roudupfinalamount;

          $("#emi-amount").html(roudupfinalamountwithcurrency);

        });
      });
    };

    rangeSlider();

    /*calculator end*/
  
    /*menu clickable*/

       $('.navmenu-link-parent').click(function() {
       		window.location = $(this).attr('href');
       });
  
  	/*menu clickable */
  
	// Banner slider
      $('.home-banner').slick({
        arrows: true,
        centerPadding: "0px",
        slidesToShow: 1,
        infinite: true, 
        autoplay: true,
        autoplaySpeed: 5000,
        dots:false,
        draggable:true,
        appendArrows: $(".banner-arrow"),
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>',

      });
    
   // Featured Product Slider
  
        $('.featured-slider').slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: true,
            appendArrows: $(".small-arrow"),
            prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    		nextArrow: '<button class="slide-arrow next-arrow"></button>',

            responsive: [{
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
               breakpoint: 575,
               settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
               }
            }]
        });
  
  // Featured Product Slider
  
        $('.brands-slider').slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: true,
            appendArrows: $(".small-arrow1"),
            prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    		nextArrow: '<button class="slide-arrow next-arrow"></button>',

            responsive: [{
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
               breakpoint: 575,
               settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
               }
            }]
        });
  
  
  
  // Js for SVG
    jQuery('img.svg').each(function(){
      var $img = jQuery(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');
      jQuery.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if(typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if(typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass+' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Check if the viewport is set, else we gonna set it if we can.
            if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
              $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
            }

            // Replace image with new SVG
            $img.replaceWith($svg);

          }, 'xml');
    });

  // Get Finance Modal Elem and Add to Body
  const finElem = $('#finance-form-modal').prop('outerHTML');
  $('#finance-form-modal').remove();
  $(finElem).appendTo('body');
  
  // Get Calc Modal Elem and Add to Body
  const calcElem = $('#finance-calc-modal').prop('outerHTML');
  $('#finance-calc-modal').remove();
  $(calcElem).appendTo('body');

  
  // Open the Finance Form Modal
  $('.finance-request-button').click(function(){
    showOverlay();
    showModal();
    hideOverflow();
  })

  // Open the Calc Form Modal
  $('.payment-calculator-button').click(function(){
    showCalcOverlay();
    showCalcModal();
  })
  
  // Open the Finance Form Modal in Grid
  $('.finance-request-button-grid').click(function(){ 
    const price = $(this).attr("product-price-attr"); 
    $("#mc-form-loading").css('display', 'block');
    $("#mc-form-iframe").css('display', 'none');
    $("#mc-form-iframe").attr("src", `https://moneycapitalfinance.com/new-online-application-wsi-integration/?product_price=${price}&amp;part_number=NA`);
    showOverlay();
    showModal();
  })

  $('#mc-form-iframe').on("load", function() {
    if($('#mc-form-loading').css('display') == 'block'){
      setTimeout(() => {
        $("#mc-form-loading").css('display', 'none');
        $("#mc-form-iframe").css('display', 'block');
      }, 1000)
    }
  });

  // Open the Calc Form Modal in Grid 
  $('.payment-calculator-button-grid').click(function(){
    const price = $(this).attr("product-price-attr");
    $("#mc-calc-loading").css('display', 'block');
    $("#mc-calc-iframe").css('display', 'none');
    $("#mc-calc-iframe").attr("src", `https://moneycapitalfinance.com/loan-calculator-wsi-integration/?product_price=${price}&amp;part_number=NA`);
    showCalcOverlay();
    showCalcModal();
  })
  
  $('#mc-calc-iframe').on("load", function() {
    if($('#mc-calc-loading').css('display') == 'block'){
      setTimeout(() => {
        $("#mc-calc-loading").css('display', 'none');
        $("#mc-calc-iframe").css('display', 'block');
      }, 1000)
    }
  });
  
  // Close the Finance Form Modal Window by clicking the X
  $('#finance-modal-exit').click(function(){
    hideOverlay();
    hideModal();
    showOverflow();
  })
  
  // Close the Calc Form Modal Window by clicking the X
  $('#calc-modal-exit').click(function(){
    hideCalcOverlay();
    hideCalcModal();
  })

  const hideOverflow = () => document.body.style.overflow = "hidden";
  const showOverflow = () => document.body.style.overflow = "auto";

  const showOverlay = () => document.querySelector("#modal-finance-dark-overlay").style.display = "block";
  const showModal = () => document.querySelector("#finance-modal-container").style.display = "block";  
  const hideOverlay = () => document.querySelector("#modal-finance-dark-overlay").style.display = "none";
  const hideModal = () => document.querySelector("#finance-modal-container").style.display = "none";  
  
  const showCalcOverlay = () => document.querySelector("#modal-calc-dark-overlay").style.display = "block";
  const showCalcModal = () => document.querySelector("#calc-modal-container").style.display = "block";  
  const hideCalcOverlay = () => document.querySelector("#modal-calc-dark-overlay").style.display = "none";
  const hideCalcModal = () => document.querySelector("#calc-modal-container").style.display = "none";  

  // Close the Modal Window by clicking outside the box  
  window.onclick = function(event) {
    if(event.target === document.querySelector('#finance-modal-container')) {
      hideOverlay();
      hideModal();   
      showOverflow();
    }
  }
  
  // Close the Modal Window by clicking outside the box  
  window.onclick = function(event) {
    if(event.target === document.querySelector('#calc-modal-container')) {
      hideCalcOverlay();
      hideCalcModal();  
    }
  }
});